// extracted by mini-css-extract-plugin
export default {"markerCluster":"styles_markerCluster__OhaZV","countBoxOnMap":"styles_countBoxOnMap__g+azd","googleMap":"styles_googleMap__Kn8E0"};